// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ArrowLeft } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconArrowLeft(props: any) {
    return <IconBase icon={ArrowLeft} {...props} />
  }

  export default IconArrowLeft
  